import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0  153.5 46" {...props}>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="编组" fill-rule="nonzero">
        <g fill="#f63" id="路径">
          <path d="M10,20 C10,9 19,0 30,0 C35,0 40,2 43.5,5.5 C46.5,2 51,0 56,0 C65.5,0 73.5,8 73.5,17.5 C73.5,19 73.5,20 73,21.5 L75,21.5 C81.5,21.5 87,27 87,33.5 C87,40 81.5,45.5 75,45.5 L15,45.5 C6.5,45.5 0,39 0,30.5 C0,22 6.5,15.5 15,15.5 L10,20 Z"></path>
        </g>
        <g transform="translate(17.5, 15)" id="矩形">
          <rect fill="#FFFFFF" x="0" y="0" width="40" height="25" rx="3"></rect>
          <rect fill="#f63" x="4" y="6" width="32" height="4"></rect>
          <rect fill="#f63" x="4" y="14" width="8" height="4"></rect>
        </g>
        <g transform="translate(70, 5.5)" fill="#001F4D">
          <text id="WORLD" font-family="Arial-BoldMT, Arial" font-size="19" font-weight="bold">
            <tspan x="0" y="17">
              WORLD
            </tspan>
          </text>
          <text id="cloud" font-family="ArialMT, Arial" font-size="16" font-weight="normal">
            <tspan x="0" y="36.5">
              cloud
            </tspan>
          </text>
          <text id="PAY" font-family="Arial-BoldMT, Arial" font-size="16" font-weight="bold">
            <tspan x="52.5" y="36.5">
              PAY
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
);

export default CMP;
